!function () {
  'use strict';

  /* =======================================================================
     Pashion Customizer – Data Layer
     Storefront API helpers shared with the original wizard implementation.
     ======================================================================= */

  function getDomain() {
    if (typeof window !== 'undefined' && window.Shopify && window.Shopify.shop) {
      return window.Shopify.shop;
    }
    if (typeof window !== 'undefined' && window.location && window.location.hostname) {
      return window.location.hostname;
    }
    return 'pashionfootweardev.myshopify.com';
  }

  var domain = getDomain();
  var storefrontToken = '4fce6efe5bbcab6c952dfe323478ec6a';
  var UPPER_COLLECTION = 'gid://shopify/Collection/283218018502';
  var HEEL_COLLECTION  = 'gid://shopify/Collection/312730353862';

  var SIZE_OPTIONS = ['5','5.5','6','6.5','7','7.5','8','8.5','9','9.5','10','11'];

  var CLOSE_ICON_SVG = '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M8.99984 10.2951L1.56834 17.7263C1.43589 17.859 1.27334 17.9298 1.08069 17.9388C0.88828 17.948 0.716761 17.8771 0.566136 17.7263C0.415274 17.5757 0.339844 17.4086 0.339844 17.2252C0.339844 17.0417 0.415274 16.8747 0.566136 16.7241L7.99729 9.29257L0.566136 1.86106C0.433453 1.72861 0.362626 1.56607 0.353655 1.37342C0.344447 1.181 0.415274 1.00948 0.566136 0.858859C0.716761 0.707997 0.883794 0.632568 1.06724 0.632568C1.25068 0.632568 1.41771 0.707997 1.56834 0.858859L8.99984 8.29001L16.4314 0.858859C16.5638 0.726176 16.7263 0.655349 16.919 0.646378C17.1114 0.63717 17.2829 0.707997 17.4336 0.858859C17.5844 1.00948 17.6598 1.17652 17.6598 1.35996C17.6598 1.5434 17.5844 1.71044 17.4336 1.86106L10.0024 9.29257L17.4336 16.7241C17.5662 16.8565 17.6371 17.0191 17.646 17.2117C17.6552 17.4041 17.5844 17.5757 17.4336 17.7263C17.2829 17.8771 17.1159 17.9526 16.9325 17.9526C16.749 17.9526 16.582 17.8771 16.4314 17.7263L8.99984 10.2951Z" fill="#1C1B1F"/></svg>';

  var HEEL_TYPES = [
    { selector: 'Block Heel Kit 4',           bottomSelector: 'b4',  height: 4,  type: 'Block' },
    { selector: 'Block Heel Kit 3',           bottomSelector: 'b3',  height: 3,  type: 'Block' },
    { selector: 'Block Heel Kit 1.5',         bottomSelector: 'b15', height: 15, type: 'Block' },
    { selector: 'Flare Block Heel Kit 4',     bottomSelector: 'fb4', height: 4,  type: 'Flare Block' },
    { selector: 'Flare Block Heel Kit 3',     bottomSelector: 'fb3', height: 3,  type: 'Flare Block' },
    { selector: 'Flare Stiletto Heel Kit 4',  bottomSelector: 'fs4', height: 4,  type: 'Flare Stiletto' },
    { selector: 'Flare Stiletto Heel Kit 3',  bottomSelector: 'fs3', height: 3,  type: 'Flare Stiletto' },
    { selector: 'Stiletto Heel Kit 4',        bottomSelector: 's4',  height: 4,  type: 'Stiletto' },
    { selector: 'Stiletto Heel Kit 3',        bottomSelector: 's3',  height: 3,  type: 'Stiletto' },
    { selector: 'Cylinder Block Heel Kit 4',  bottomSelector: 'cb4', height: 4,  type: 'Cylinder Block' },
    { selector: 'Cylinder Block Heel Kit 3',  bottomSelector: 'cb3', height: 3,  type: 'Cylinder Block' }
  ];

  /* ------- GraphQL Queries ------- */

  var QUERY_LIGHT = [
    'query getCollectionFiltersLight($id: ID!, $filters: [ProductFilter!], $first: Int = 100, $country: CountryCode) @inContext(country: $country) {',
    '  collection(id: $id) {',
    '    title',
    '    products(first: $first, filters: $filters) {',
    '      pageInfo { hasNextPage endCursor }',
    '      edges { node {',
    '        id title handle availableForSale',
    '        featuredImage { url altText width height }',
    '        metafield_option_color: metafield(namespace: "cvm", key: "option_color") { value }',
    '        variants(first: 50) { edges { node {',
    '          id availableForSale price { amount currencyCode } title quantityAvailable',
    '          selectedOptions { name value }',
    '        } } }',
    '      } }',
    '      filters { id label type values { id label count input } }',
    '    }',
    '  }',
    '}'
  ].join('\n');

  var QUERY_FULL = [
    'query getCollectionFilters($id: ID!, $filters: [ProductFilter!], $cursor: String, $country: CountryCode) @inContext(country: $country) {',
    '  collection(id: $id) {',
    '    title',
    '    products(first: 250, filters: $filters, after: $cursor) {',
    '      pageInfo { hasNextPage endCursor }',
    '      edges { node {',
    '        id title handle availableForSale',
    '        featuredImage { url altText width height }',
    '        metafield_option_color: metafield(namespace: "cvm", key: "option_color") { value }',
    '        metafield_heel_image: metafield(namespace: "cvm", key: "customizer_heel") {',
    '          key reference { ... on MediaImage { image { url altText width height } } }',
    '        }',
    '        metafield_color_pattern: metafield(namespace: "shopify", key: "color-pattern") {',
    '          references(first: 10) { edges { node { ... on Metaobject {',
    '            label: field(key: "label") { value }',
    '            color: field(key: "color") { value }',
    '          } } } }',
    '        }',
    '        metafield_upper_image_1_5: metafield(namespace: "cvm", key: "upper_image_1-5") {',
    '          key reference { ... on MediaImage { image { url altText width height } } }',
    '        }',
    '        metafield_upper_image_3: metafield(namespace: "cvm", key: "upper_image_3") {',
    '          key reference { ... on MediaImage { image { url altText width height } } }',
    '        }',
    '        metafield_upper_image_4: metafield(namespace: "cvm", key: "upper_image_4") {',
    '          key reference { ... on MediaImage { image { url altText width height } } }',
    '        }',
    '        variants(first: 250) { edges { node {',
    '          id availableForSale price { amount currencyCode } title quantityAvailable',
    '          selectedOptions { name value }',
    '        } } }',
    '      } }',
    '      filters { id label type values { id label count input } }',
    '    }',
    '  }',
    '}'
  ].join('\n');

  /* ------- Storefront Fetch ------- */

  /* Every query runs in the shopper's market (@inContext), so prices come back
     in the presented currency with market pricing and rounding applied. */
  function storefrontFetch(query, variables) {
    variables.country = (window.Shopify && window.Shopify.country) || null;
    return fetch('https://' + domain + '/api/2024-10/graphql.json', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': storefrontToken
      },
      body: JSON.stringify({ query: query, variables: variables })
    }).then(function (res) { return res.json(); });
  }

  function fetchFiltersLight(opts) {
    return storefrontFetch(QUERY_LIGHT, {
      id: opts.collectionId,
      filters: (opts.filters || []).filter(Boolean),
      first: opts.maxProducts || 100
    }).then(function (response) {
      if (response.errors) console.error('fetchFiltersLight errors:', response.errors);
      var col = (response.data && response.data.collection) || {};
      var prods = col.products || {};
      return prods.filters || [];
    });
  }

  function fetchFilters(opts) {
    var filters = opts.filters || [];
    var allEdges = [];

    function fetchPage(cursor) {
      return storefrontFetch(QUERY_FULL, {
        id: opts.collectionId,
        filters: filters.filter(Boolean),
        cursor: cursor
      }).then(function (response) {
        if (response.errors) console.error('fetchFilters errors:', response.errors);
        var col = (response.data && response.data.collection) || {};
        var prods = col.products || {};
        allEdges = allEdges.concat(prods.edges || []);
        var pageInfo = prods.pageInfo;
        if (pageInfo && pageInfo.hasNextPage) return fetchPage(pageInfo.endCursor);
        return allEdges;
      });
    }

    return fetchPage(null);
  }

  /* ------- Upper Helpers ------- */

  function getActiveStyleFilters(filters, baseProductStyle) {
    var acc = [];
    filters.forEach(function (item) {
      if (item.id === 'filter.p.m.cvm.style_title' && item.values) {
        item.values.forEach(function (v) {
          if (v.label && v.label.toLowerCase().indexOf(baseProductStyle.toLowerCase()) !== -1) {
            acc.push(JSON.parse((v.input || '{}').replace(/\\/g, '')));
          }
        });
      }
    });
    return acc;
  }

  function findTopImages(productData, color, selectedSize) {
    var topImages = {};
    for (var s = 0; s < SIZE_OPTIONS.length; s++) {
      for (var p = 0; p < productData.length; p++) {
        var product = productData[p].node;
        if (!product.availableForSale) continue;
        var matchingVariant = null;
        var edges = product.variants.edges;
        for (var v = 0; v < edges.length; v++) {
          var opts = edges[v].node.selectedOptions;
          if (opts) {
            for (var o = 0; o < opts.length; o++) {
              if (opts[o].name.toLowerCase() === 'size' && opts[o].value === selectedSize) {
                matchingVariant = edges[v];
                break;
              }
            }
          }
          if (matchingVariant) break;
        }
        if (!matchingVariant) matchingVariant = edges[0];
        if (color && (!product.metafield_option_color || product.metafield_option_color.value !== color)) continue;

        var refs = {
          15: product.metafield_upper_image_1_5,
          3: product.metafield_upper_image_3,
          4: product.metafield_upper_image_4
        };
        for (var height in refs) {
          var ref = refs[height];
          if (ref && ref.reference && ref.reference.image && ref.reference.image.url) {
            topImages[height] = {
              upperImageUrl: ref.reference.image.url, height: Number(height),
              productId: product.id, featuredImage: product.featuredImage,
              variant: matchingVariant ? matchingVariant.node : null,
              size: selectedSize || ''
            };
          }
        }
        if (Object.keys(topImages).length === 0) continue;
        return topImages;
      }
    }
    return null;
  }

  /* Per-color size availability across the style's uppers. One upper product
     per color; sizes marked available when that size's variant is in stock.
     allSizes tracks every size that exists on any color (in stock or not). */
  function buildColorMatrix(edges) {
    var colors = [];
    var seenColors = {};
    var allSizes = {};

    edges.forEach(function (item) {
      var product = item.node;
      var color = product.metafield_option_color ? product.metafield_option_color.value : null;
      if (!color || seenColors[color]) return;
      seenColors[color] = true;

      var sizes = {};
      product.variants.edges.forEach(function (e) {
        var variant = e.node;
        var sizeOpt = (variant.selectedOptions || []).find(function (o) {
          return o.name.toLowerCase() === 'size';
        });
        if (!sizeOpt) return;
        allSizes[sizeOpt.value] = true;
        if (variant.availableForSale) sizes[sizeOpt.value] = true;
      });

      colors.push({
        color: color,
        swatchUrl: product.featuredImage ? product.featuredImage.url : null,
        sizes: sizes
      });
    });

    return { colors: colors, allSizes: allSizes };
  }

  function getFormattedSize(size) {
    /* Already a grouped heel-kit size (e.g. "5-6.5") — pass through */
    if (typeof size === 'string' && size.indexOf('-') !== -1) return size;
    size = parseFloat(size);
    if (!size) return null;
    return size < 7 ? '5-6.5' : size >= 9 ? '9-11' : '7-8.5';
  }

  /* ------- Heel Kit Grid ------- */

  /* Every heel kit product (type + height + color combo) with the variant
     for the shopper's size. Only available kits are returned. Order follows
     HEEL_TYPES: grouped by type, heights descending within each type. */
  function getAllKits(products, size) {
    var formattedSize = getFormattedSize(size);
    if (!formattedSize) return [];
    var kits = [];
    var seen = {};

    HEEL_TYPES.forEach(function (heel) {
      var selector = heel.selector.toLowerCase();
      products.forEach(function (item) {
        var product = item.node;
        if (!product.title || seen[product.id]) return;
        var title = product.title.toLowerCase();
        if (title.indexOf(selector) === -1) return;
        /* Guard partial matches: "Flare Block…"/"Cylinder Block…" contain "Block…" */
        if (selector.indexOf('flare') === -1 && title.indexOf('flare') !== -1) return;
        if (selector.indexOf('cylinder') === -1 && title.indexOf('cylinder') !== -1) return;
        if (!product.availableForSale) return;

        var heelRef = product.metafield_heel_image;
        var imageUrl = heelRef && heelRef.reference && heelRef.reference.image ? heelRef.reference.image.url : null;
        if (!imageUrl) return;

        var variantEdge = product.variants.edges.find(function (e) {
          return e.node.title === formattedSize && e.node.availableForSale;
        });
        if (!variantEdge) return;

        /* Category (taxonomy) Color labels from shopify.color-pattern */
        var colorEdges = product.metafield_color_pattern && product.metafield_color_pattern.references
          ? product.metafield_color_pattern.references.edges : [];
        var colorTags = [];
        colorEdges.forEach(function (e) {
          var label = e.node && e.node.label && e.node.label.value;
          if (label && colorTags.indexOf(label) === -1) colorTags.push(label);
        });

        seen[product.id] = true;
        kits.push({
          selector: heel.selector, bottomSelector: heel.bottomSelector,
          height: heel.height, type: heel.type,
          color: product.metafield_option_color ? product.metafield_option_color.value : null,
          colorTags: colorTags,
          heelImageUrl: imageUrl,
          productId: product.id, productTitle: product.title,
          featuredImage: product.featuredImage,
          variant: variantEdge.node
        });
      });
    });

    return kits;
  }

  /* ------- Bundle Pricing & Cart (Flex Bundles _components) ------- */

  /* Fallback when no customizer_discount_tier metaobject entries exist */
  var DEFAULT_DISCOUNT_TIERS = [
    { minKits: 3, discount: 10 },
    { minKits: 4, discount: 15 }
  ];

  function getVariantPrice(item) {
    return item && item.variant && item.variant.price ? parseFloat(item.variant.price.amount) || 0 : 0;
  }

  /* Storefront prices are in the presented currency; theme.formatMoney takes cents */
  function formatMoney(amount) {
    var cents = Math.round((amount || 0) * 100);
    if (window.theme && window.theme.formatMoney) return window.theme.formatMoney(cents, window.theme.moneyFormat);
    return (cents / 100).toFixed(2);
  }

  /* Highest tier whose minKits the current kit count satisfies; 0 below the first tier */
  function getTierDiscount(tiers, kitCount) {
    var discount = 0;
    tiers.forEach(function (t) {
      if (kitCount >= t.minKits && t.discount > discount) discount = t.discount;
    });
    return discount;
  }

  /* Tiers still above the current kit count, for "Add N more & save X%" messaging */
  function getUpcomingTiers(tiers, kitCount) {
    return tiers.filter(function (t) { return t.minKits > kitCount; });
  }

  function getBundlePricing(topImage, kits, tiers) {
    var retail = getVariantPrice(topImage);
    kits.forEach(function (k) { retail += getVariantPrice(k); });
    var discount = getTierDiscount(tiers, kits.length);
    var total = Math.round(retail * (100 - discount)) / 100;
    var savings = Math.round((retail - total) * 100) / 100;
    return {
      retailTotal: retail,
      discountPercent: discount,
      total: total,
      savings: savings
    };
  }

  function handleBundleAddToCart(button, parentVariantId, topImage, kits, tiers, quantity, bundleTitle, bundleUrl, onComplete) {
    var topId = topImage && topImage.variant && topImage.variant.id ? topImage.variant.id.split('/').pop() : null;
    if (!parentVariantId || !topId || !kits.length) { console.error('[customizer] Invalid bundle'); return; }

    var pricing = getBundlePricing(topImage, kits, tiers);

    /* Flex Bundles Component Sum mode: each component carries its (discounted)
       price; the discount is explained via component attributes. Component
       quantities are per bundle unit — the parent line quantity multiplies. */
    var components = [topImage].concat(kits).map(function (c) {
      var price = getVariantPrice(c);
      var discounted = Math.round(price * (100 - pricing.discountPercent)) / 100;
      var entry = {
        id: Number(c.variant.id.split('/').pop()),
        quantity: 1,
        price: discounted
      };
      if (pricing.discountPercent > 0) {
        entry.attributes = {
          'Original Price': formatMoney(price),
          'You Save': formatMoney(Math.round((price - discounted) * 100) / 100)
        };
      }
      return entry;
    });

    /* Component prices are in the presented currency (see storefrontFetch);
       Flex Bundles divides by this rate to normalize them to the shop currency.
       Fall back to rate 1 if the API returned a different currency (e.g. the
       market context was unavailable and prices came back in shop currency). */
    var currency = (window.Shopify && window.Shopify.currency) || {};
    var priceCurrency = topImage.variant.price && topImage.variant.price.currencyCode;
    var inPresented = [topImage].concat(kits).every(function (c) {
      return c.variant && c.variant.price && c.variant.price.currencyCode === currency.active;
    });
    if (!inPresented) console.warn('[customizer] Prices not in presented currency ' + currency.active + '; sending rate 1');

    var properties = {
      '_components': JSON.stringify(components),
      '_currency': (inPresented ? currency.active : priceCurrency) || '',
      '_currency_rate': inPresented ? String(currency.rate || '1') : '1'
    };

    /* Cart line title/image for the generic parent product */
    var settings = {};
    if (bundleTitle) settings.title = bundleTitle;
    if (topImage.featuredImage && topImage.featuredImage.url) settings.image = topImage.featuredImage.url;
    if (settings.title || settings.image) properties['_settings'] = JSON.stringify(settings);
    /* Theme-readable duplicates — Liquid can't parse the _settings JSON */
    if (bundleTitle) properties['_bundle_title'] = bundleTitle;
    /* Cart line links here instead of the unlisted parent product (404) */
    if (bundleUrl) properties['_bundle_url'] = bundleUrl;

    if (topImage.featuredImage && topImage.featuredImage.url) {
      properties['_upper_image'] = topImage.featuredImage.url;
    }
    kits.forEach(function (k, i) {
      if (k.featuredImage && k.featuredImage.url) {
        properties['_heel_' + (i + 1) + '_image'] = k.featuredImage.url;
      }
    });
    properties['Retail Price'] = formatMoney(pricing.retailTotal);
    if (pricing.savings > 0) {
      properties['Savings'] = formatMoney(pricing.savings) + ' (' + pricing.discountPercent + '%)';
    }

    /* Parent = the registered "Customized Bundle" product; Flex Bundles only
       processes lines whose parent variant is set up as a bundle in the app. */
    var items = [{ id: Number(parentVariantId), quantity: quantity, properties: properties }];

    var cartUrl = (typeof theme !== 'undefined' && theme.routes && theme.routes.cart_add_url)
      ? theme.routes.cart_add_url : '/cart/add.js';

    button.classList.add('is-loading');
    button.disabled = true;

    /* Close modal immediately for instant feedback */
    if (onComplete) onComplete();

    fetch(cartUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify({ items: items })
    })
    .then(function (res) { return res.json(); })
    .then(function (response) {
      button.classList.remove('is-loading');
      button.disabled = false;
      if (response.status) {
        console.error('[customizer] Add to cart error:', response.description);
        return;
      }
      /* Refresh cart drawer — triggers getCart() in the Broadcast cart system */
      document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
    })
    .catch(function (err) {
      button.classList.remove('is-loading');
      button.disabled = false;
      console.error('[customizer] Add to cart fetch error:', err);
    });
  }

  /* =======================================================================
     Custom Element: <pashion-customizer>
     Single-screen bundle builder. Size, upper color, heel height, and the
     first heel kit are inherited from the PDP variant picker; the grid
     lets the shopper check additional heel kits (all type + color combos
     at the PDP heel height) and preview any of them on the left.
     ======================================================================= */

  if (customElements.get('pashion-customizer')) return;

  customElements.define('pashion-customizer', class extends HTMLElement {
    constructor() {
      super();

      this.quantity = 1;
      this.isLoading = false;
      this.loaded = false;

      /* 'intro' (how it works) | 'options' (size + upper color) | 'kits' (heel kit grid) */
      this.screen = 'intro';

      this.upperEdges = [];
      this.heelEdges = [];
      this.upperColors = [];   /* [{ color, swatchUrl, sizes: {size: true} }] */
      this.upperSizes = {};    /* every size that exists on any color */

      /* Inherited from the PDP */
      this.selectedSize = null;   /* e.g. "6.5" */
      this.upperColor = null;     /* e.g. "Coal Leather" */
      this.pdpSwatches = {};      /* lowercased color -> { color, image } from PDP swatch buttons */
      this.heelHeight = 3;        /* 3 | 4 | 15 */
      this.pdpHeelType = null;    /* e.g. "Stiletto" */
      this.pdpHeelColor = null;   /* e.g. "Coal" */

      this.topImages = null;
      this.topImage = null;

      this.gridKits = [];
      this.selectedKitIds = {};   /* variant id -> kit */
      this.previewKit = null;
      this.kitFilter = 'all';       /* 'all' | heel type name */
      this.kitHeightFilter = 'all'; /* 'all' | 3 | 4 | 15 */
      this.kitColorFilter = 'all';  /* 'all' | category Color label */
      this.bundleOpen = false;    /* "See Your Bundle" panel expanded */

      this.discountTiers = DEFAULT_DISCOUNT_TIERS;
    }

    connectedCallback() {
      this.productStyle = this.dataset.styleTitle || '';
      this.modal = this.querySelector('[data-customizer-modal]');
      this.body = this.querySelector('[data-customizer-body]');

      /* Portal the modal to <body>: ancestors inside the product section
         create stacking contexts that trap the modal's z-index below the
         stuck header, no matter how high it's set. */
      if (this.modal && this.modal.parentNode !== document.body) {
        document.body.appendChild(this.modal);
      }

      /* Discount tiers from the customizer_discount_tier metaobject (via Liquid).
         Once any entries exist they're used as-is, so setting every entry's
         discount_percentage to 0 turns bundle discounts off; the defaults only
         apply when there are no entries at all. */
      try {
        var tiers = JSON.parse(this.dataset.discountTiers || '[]');
        if (Array.isArray(tiers) && tiers.length) {
          this.discountTiers = tiers
            .filter(function (t) { return t && t.minKits > 0 && t.discount > 0; })
            .sort(function (a, b) { return a.minKits - b.minKits; });
        }
      } catch (e) {
        console.warn('[customizer] Invalid data-discount-tiers, using defaults');
      }

      /* Heel context is fixed per combined-listing product (from Liquid) */
      this.pdpHeelType = this.dataset.pdpHeelType || null;
      this.pdpHeelColor = this.dataset.pdpHeelColor || null;
      var rawHeight = parseFloat(this.dataset.pdpHeelHeight || '3');
      this.heelHeight = rawHeight === 1.5 ? 15 : (rawHeight === 4 ? 4 : 3);

      this._readProductForm();

      /* Trigger button */
      this._trigger = this.querySelector('[data-customizer-open]');
      if (this._trigger) {
        this._onOpen = this.open.bind(this);
        this._trigger.addEventListener('click', this._onOpen);
      }

      /* Deep link — auto-open the modal once the data fetch lands.
         ?customize=1 is the link format used on the previous (Focal) theme and
         in existing marketing links; ?customizer (any value) is kept too. */
      try {
        var params = new URLSearchParams(window.location.search);
        this._autoOpen = params.has('customize') || params.has('customizer');
      } catch (e) {
        this._autoOpen = false;
      }

      /* Close handlers */
      this._onClose = function (e) {
        if (e.target.hasAttribute('data-customizer-close')) this.close();
      }.bind(this);
      this._onKeydown = function (e) {
        if (e.key === 'Escape') this.close();
      }.bind(this);
      if (this.modal) this.modal.addEventListener('click', this._onClose);
      document.addEventListener('keydown', this._onKeydown);

      if (this.productStyle) this._initData();
    }

    disconnectedCallback() {
      if (this._trigger && this._onOpen) this._trigger.removeEventListener('click', this._onOpen);
      if (this.modal) this.modal.removeEventListener('click', this._onClose);
      document.removeEventListener('keydown', this._onKeydown);
      /* Remove the portaled modal — section re-renders create a fresh one */
      if (this.modal && this.modal.parentNode === document.body) {
        document.body.removeChild(this.modal);
        document.body.style.overflow = '';
      }
    }

    /* --- PDP variant picker --- */

    _readProductForm() {
      var picker = document.querySelector('variant-selects[data-section="' + (this.dataset.sectionId || '') + '"]')
        || document.querySelector('variant-selects');
      if (!picker) return;
      var self = this;
      var sawColor = false;
      picker.querySelectorAll('input[type="radio"]:checked').forEach(function (input) {
        var name = input.name || '';
        if (name.indexOf('Size') === 0) self.selectedSize = input.value;
        else if (name.indexOf('Color') === 0) { self.upperColor = input.value; sawColor = true; }
      });
      /* Upper PDPs are one product per color with no Color option — fall
         back to the product's own cvm.option_color (via Liquid) */
      if (!sawColor && this.dataset.pdpUpperColor) this.upperColor = this.dataset.pdpUpperColor;
      this._readPdpSwatches(picker);
    }

    /* Admin-configured color swatches, read off the PDP's own swatch buttons
       so the modal circles match the variant picker exactly. Colors without a
       configured swatch (empty --swatch) fall back to the upper's featured
       image. Also captures each color's PDP url (combined-listing swap
       target) for the cart line's link. */
    _readPdpSwatches(picker) {
      var self = this;
      this.pdpSwatches = {};
      picker.querySelectorAll('.swatch__button input[type="radio"]').forEach(function (input) {
        if ((input.name || '').indexOf('Color') !== 0 || !input.value) return;
        var button = input.closest('.swatch__button');
        var label = button && button.querySelector('label');
        if (!button || !label) return;
        var entry = {
          image: null,
          color: null,
          url: input.getAttribute('data-product-url') || null
        };
        if (button.style.getPropertyValue('--swatch').trim()) {
          var style = window.getComputedStyle(label);
          entry.image = style.backgroundImage !== 'none' ? style.backgroundImage : null;
          entry.color = style.backgroundColor !== 'rgba(0, 0, 0, 0)' ? style.backgroundColor : null;
        }
        if (entry.image || entry.color || entry.url) self.pdpSwatches[input.value.toLowerCase()] = entry;
      });
    }

    /* PDP url for the selected upper color — where the cart line links back
       to. Falls back to the page the bundle was built on. */
    _bundleUrl() {
      var entry = this.pdpSwatches[(this.upperColor || '').toLowerCase()];
      return (entry && entry.url) || window.location.pathname;
    }

    /* --- Modal control --- */

    open() {
      if (!this.modal) return;
      /* PDP picks can change without a section re-render — re-read and rebuild */
      this._readProductForm();
      if (this.loaded && this.upperColors.length) {
        var entry = this._colorEntry(this.upperColor);
        /* Normalize the PDP option value to the metafield color casing */
        if (entry) this.upperColor = entry.color;
        /* PDP color sold out in the PDP size — clear it so the swatches steer
           the shopper to a color that IS available in their size */
        if (this.upperColor && this.selectedSize && (!entry || !entry.sizes[this.selectedSize])) {
          this.upperColor = null;
        }
      }
      if (this.loaded) this._processData();
      this.screen = 'intro';
      this.kitFilter = 'all';
      this.kitHeightFilter = 'all';
      this.kitColorFilter = 'all';
      this.bundleOpen = false;

      this.modal.hidden = false;
      document.body.style.overflow = 'hidden';
      if (window.theme && window.theme.a11y) window.theme.a11y.trapFocus(this.modal);
      this._render();
    }

    close() {
      if (!this.modal) return;
      this.modal.hidden = true;
      document.body.style.overflow = '';
      if (window.theme && window.theme.a11y) window.theme.a11y.removeTrapFocus();
      this._grid = null;
    }

    /* --- Data --- */

    _initData() {
      var self = this;
      self.isLoading = true;
      self._updateTrigger();

      var baseStyle = self.productStyle.split('-')[0];

      fetchFiltersLight({ collectionId: UPPER_COLLECTION, maxProducts: 100 })
        .then(function (upperFilters) {
          var styleFilters = getActiveStyleFilters(upperFilters, baseStyle);
          return Promise.all([
            fetchFilters({ filters: styleFilters, collectionId: UPPER_COLLECTION }),
            fetchFilters({ filters: [], collectionId: HEEL_COLLECTION })
          ]);
        })
        .then(function (results) {
          self.upperEdges = results[0] || [];
          self.heelEdges = results[1] || [];
          var matrix = buildColorMatrix(self.upperEdges);
          self.upperColors = matrix.colors;
          self.upperSizes = matrix.allSizes;
          self.isLoading = false;
          self.loaded = true;
          self._processData();
          self._updateTrigger();
          if (self._autoOpen) {
            self._autoOpen = false;
            if (self.modal && self.modal.hidden) self.open();
          }
        })
        .catch(function (err) {
          console.error('[customizer] Init error:', err);
          self.isLoading = false;
          self._updateTrigger();
        });
    }

    _processData() {
      var self = this;

      /* Upper composited image at the selected heel height + size. With a
         color chosen, never fall back to another color — the fallback's
         variant would end up in the cart. Color-less fallback is only a
         decorative preview while nothing is selected on screen 1. */
      this.topImages = this.upperColor
        ? findTopImages(this.upperEdges, this.upperColor, this.selectedSize)
        : findTopImages(this.upperEdges, null, this.selectedSize);
      this.topImage = this.topImages
        ? (this.topImages[this.heelHeight] || this.topImages[3] || this.topImages[4] || this.topImages[15])
        : null;

      /* Grid: every available heel kit (all types + heights) for this size */
      this.gridKits = getAllKits(this.heelEdges, Number(this.selectedSize));

      /* Preserve selections across size changes where possible */
      var previous = this.selectedKitIds;
      this.selectedKitIds = {};
      this.gridKits.forEach(function (kit) {
        for (var id in previous) {
          if (previous[id].productId === kit.productId) self.selectedKitIds[self._kitId(kit)] = kit;
        }
      });

      /* No kit pre-checked — selection starts at 0. The PDP-selected heel
         only seeds the preview image. Re-resolve a previewed kit into the
         new grid (its variant is size-specific and may be gone). */
      if (this.previewKit) {
        var previewProductId = this.previewKit.productId;
        this.previewKit = this.gridKits.find(function (kit) {
          return kit.productId === previewProductId;
        }) || null;
      }
      if (!this.previewKit) {
        this.previewKit = this._findPdpKit() || this.gridKits[0] || null;
      }
    }

    _findPdpKit() {
      var self = this;
      if (!this.pdpHeelType) return null;
      var typeMatches = this.gridKits.filter(function (kit) {
        return kit.height === self.heelHeight
          && kit.type && kit.type.toLowerCase() === self.pdpHeelType.toLowerCase();
      });
      if (!typeMatches.length) return null;
      if (this.pdpHeelColor) {
        var colorMatch = typeMatches.find(function (kit) {
          return kit.color && kit.color.toLowerCase() === self.pdpHeelColor.toLowerCase();
        });
        if (colorMatch) return colorMatch;
      }
      return typeMatches[0];
    }

    _kitId(kit) {
      return kit.variant && kit.variant.id ? kit.variant.id : kit.productId;
    }

    /* --- Size + upper color selection (screen 1) --- */

    /* Colors offered in the customizer = colors on the PDP's own picker.
       The Uppers collection also holds uppers that aren't in the combined
       listing (e.g. FINAL SALE flats) — those must not be sold through the
       bundle. Matching is by name (case-insensitive), so a PDP option value
       spelled differently from the upper's cvm.option_color drops out too.
       If no PDP swatches were found at all, fall back to the full list. */
    _availableColors() {
      var swatches = this.pdpSwatches;
      if (!Object.keys(swatches).length) return this.upperColors;
      return this.upperColors.filter(function (entry) {
        return !!swatches[entry.color.toLowerCase()];
      });
    }

    _colorEntry(color) {
      if (!color) return null;
      return this._availableColors().find(function (c) {
        return c.color.toLowerCase() === color.toLowerCase();
      }) || null;
    }

    _sizeHasAnyColor(size) {
      return this._availableColors().some(function (c) { return c.sizes[size]; });
    }

    _comboAvailable() {
      if (!this.selectedSize || !this.upperColor) return false;
      var entry = this._colorEntry(this.upperColor);
      return !!(entry && entry.sizes[this.selectedSize] && this.topImage && this.topImage.variant);
    }

    _selectSize(size) {
      this.selectedSize = size;
      /* The point of this screen: if the chosen color is out in this size,
         clear it so the struck/available swatches guide the shopper to a
         color that IS in their size. */
      var entry = this._colorEntry(this.upperColor);
      if (this.upperColor && (!entry || !entry.sizes[size])) this.upperColor = null;
      this._processData();
      this._render();
    }

    _selectColor(color) {
      this.upperColor = color;
      this._processData();
      this._render();
    }

    _selectedKits() {
      var self = this;
      return Object.keys(this.selectedKitIds).map(function (id) { return self.selectedKitIds[id]; });
    }

    _toggleKit(kit) {
      var id = this._kitId(kit);
      if (this.selectedKitIds[id]) {
        delete this.selectedKitIds[id];
      } else {
        this.selectedKitIds[id] = kit;
        this.previewKit = kit;
      }
      this._render();
    }

    _updateTrigger() {
      var trigger = this.querySelector('[data-customizer-open]');
      if (!trigger) return;
      trigger.disabled = this.isLoading || !this.loaded;
      var btnText = this.dataset.buttonText || 'Build Your Bundle';
      /* Deep-linked auto-open: tell the shopper the modal is coming */
      trigger.textContent = this.isLoading
        ? (this._autoOpen ? 'Opening...' : 'Loading...')
        : btnText;
    }

    /* --- Rendering --- */

    /* Re-render without losing the user's place — clearing _contentInner
       collapses its scrollHeight, which clamps scrollTop to 0 */
    _renderKeepingScroll() {
      var scrollTop = this._contentInner ? this._contentInner.scrollTop : 0;
      this._render();
      if (this._contentInner) this._contentInner.scrollTop = scrollTop;
    }

    _render() {
      if (!this.body) return;

      if (!this._grid) {
        this.body.innerHTML = '';
        this._grid = this._el('div', 'pc-modal__grid');

        /* Image column — persists across renders */
        this._imgCol = this._el('div', 'pc-modal__image-col');
        this._imgStack = this._el('div', 'pc-image-stack');
        this._upperImg = document.createElement('img');
        this._upperImg.className = 'pc-image-stack__upper';
        this._upperImg.alt = this.productStyle + ' upper';
        this._imgStack.appendChild(this._upperImg);
        this._heelImg = document.createElement('img');
        this._heelImg.className = 'pc-image-stack__heel';
        this._heelImg.alt = 'Heel overlay';
        this._imgStack.appendChild(this._heelImg);
        this._imgCol.appendChild(this._imgStack);

        /* Mobile close X — overlaid top-right of the image (stacked layout) */
        var imgClose = this._el('button', 'pc-modal__close-img');
        imgClose.setAttribute('aria-label', 'Close');
        imgClose.innerHTML = CLOSE_ICON_SVG;
        imgClose.addEventListener('click', this.close.bind(this));
        this._imgCol.appendChild(imgClose);

        this._grid.appendChild(this._imgCol);

        /* Content column */
        this._contentCol = this._el('div', 'pc-modal__content-col');
        this._contentInner = this._el('div', 'pc-modal__content-inner');
        this._contentCol.appendChild(this._contentInner);
        this._grid.appendChild(this._contentCol);

        this.body.appendChild(this._grid);
      }

      this._updateImages();
      this._contentInner.innerHTML = '';

      /* Close button — inside content area (desktop; mobile uses the image X) */
      var closeBtn = this._el('button', 'pc-modal__close-js');
      closeBtn.setAttribute('aria-label', 'Close');
      closeBtn.innerHTML = CLOSE_ICON_SVG;
      closeBtn.addEventListener('click', this.close.bind(this));
      this._contentInner.appendChild(closeBtn);

      /* Pricing bar + footer pinned below the scrollable content */
      var oldPricing = this._contentCol.querySelector('.pc-tray-wrap');
      if (oldPricing) oldPricing.remove();
      var oldFooter = this._contentCol.querySelector('.pc-modal__footer');
      if (oldFooter) oldFooter.remove();

      if (this.screen === 'intro') {
        this._contentInner.appendChild(this._renderIntro());
        this._contentCol.appendChild(this._renderIntroFooter());
      } else if (this.screen === 'options') {
        this._contentInner.appendChild(this._renderOptionsHeader());
        this._contentInner.appendChild(this._renderSizeOptions());
        this._contentInner.appendChild(this._renderColorOptions());
        this._contentCol.appendChild(this._renderOptionsFooter());
      } else {
        this._contentInner.appendChild(this._renderHeader());
        this._contentInner.appendChild(this._renderKitTabs());
        this._contentInner.appendChild(this._renderKitGrid());
        this._contentCol.appendChild(this._renderPricingBar());
        this._contentCol.appendChild(this._renderFooter());
      }
    }

    _updateImages() {
      var heel = this.previewKit;
      /* Upper composited at the previewed kit's height */
      var top = (heel && this.topImages && this.topImages[heel.height]) || this.topImage;

      if (top && top.upperImageUrl) {
        if (this._upperImg.src !== top.upperImageUrl) {
          this._upperImg.classList.add('is-loading');
          this._upperImg.onload = function () { this.classList.remove('is-loading'); };
          this._upperImg.src = top.upperImageUrl;
        }
        this._upperImg.style.display = '';
      } else {
        this._upperImg.style.display = 'none';
      }

      if (heel && heel.heelImageUrl) {
        if (this._heelImg.src !== heel.heelImageUrl) {
          this._heelImg.src = heel.heelImageUrl;
        }
        this._heelImg.style.display = '';
      } else {
        this._heelImg.style.display = 'none';
      }
    }

    /* --- Screen 0: how it works --- */

    /* "Save 10% with 3 Heel Kits, Save 15% on 4+" Built from the configured
       tiers so admin changes to the metaobject flow through. */
    _discountSummary() {
      var tiers = (this.discountTiers || []).slice().sort(function (a, b) {
        return a.minKits - b.minKits;
      });
      if (!tiers.length) return '';
      var parts = tiers.map(function (tier, i) {
        return i === tiers.length - 1
          ? 'Save ' + tier.discount + '% on ' + tier.minKits + '+'
          : 'Save ' + tier.discount + '% with ' + tier.minKits + ' Heel Kits';
      });
      return parts.join(', ');
    }

    _renderIntro() {
      var self = this;
      var intro = this._el('div', 'pc-intro');

      var title = this._el('h2', 'pc-modal__title');
      title.textContent = 'Build Your ' + this.productStyle + ' Bundle';
      intro.appendChild(title);

      /* Savings copy only when a discount tier is configured */
      var hasDiscount = this.discountTiers.length > 0;

      var lede = this._el('p', 'pc-intro__lede');
      lede.textContent = 'Turn one ' + this.productStyle + ' into a whole shoe rack of styles '
        + 'with interchangeable heels.' + (hasDiscount ? ' The more heels you bundle, the more you save.' : '');
      intro.appendChild(lede);

      var steps = this._el('ol', 'pc-intro__steps');
      [
        {
          title: 'Pick your size and upper color',
          text: 'You’ll start with the selection on this page — change either one in this step.'
        },
        {
          title: 'Choose your heel kits',
          text: 'Tap any heel to preview it on your shoe, then checkmark it to add to bundle. Mix heights, styles, and colors.'
        },
        {
          title: 'Add the bundle to your bag',
          text: hasDiscount
            ? 'Your discount will auto-apply in-cart & everything ships together.'
            : 'Everything ships together.'
        }
      ].forEach(function (step, i) {
        var li = self._el('li', 'pc-intro__step');

        var num = self._el('span', 'pc-intro__num');
        num.textContent = i + 1;
        li.appendChild(num);

        var copy = self._el('div', 'pc-intro__step-copy');
        var heading = self._el('span', 'pc-intro__step-title');
        heading.textContent = step.title;
        copy.appendChild(heading);
        var text = self._el('span', 'pc-intro__step-text');
        text.textContent = step.text;
        copy.appendChild(text);
        li.appendChild(copy);

        steps.appendChild(li);
      });
      intro.appendChild(steps);

      var summary = this._discountSummary();
      if (summary) {
        var perk = this._el('p', 'pc-intro__perk');
        perk.textContent = summary;
        intro.appendChild(perk);
      }

      return intro;
    }

    _renderIntroFooter() {
      var self = this;
      var footer = this._el('div', 'pc-modal__footer');

      var btn = document.createElement('button');
      btn.className = 'btn btn--primary btn--solid pc-atc-btn pc-continue-btn';
      btn.textContent = 'GET STARTED';
      btn.addEventListener('click', function () {
        self.screen = 'options';
        self._render();
      });
      footer.appendChild(btn);

      return footer;
    }

    /* --- Screen 1: size + upper color --- */

    _renderOptionsHeader() {
      var header = this._el('div', 'pc-modal__header');

      var title = this._el('h2', 'pc-modal__title');
      title.textContent = 'Build Your ' + this.productStyle + ' Bundle';
      header.appendChild(title);

      var hint = this._el('p', 'pc-modal__grid-hint');
      hint.textContent = 'Pick your size and upper color, then choose your heel kits.';
      header.appendChild(hint);

      return header;
    }

    _renderSizeOptions() {
      var self = this;
      var section = this._el('div', 'pc-options-section');

      var heading = this._el('p', 'pc-modal__step-heading');
      heading.innerHTML = 'Size: <strong>' + (this.selectedSize || '—') + '</strong>';
      section.appendChild(heading);

      var wrap = this._el('div', 'pc-modal__options');
      SIZE_OPTIONS.forEach(function (size) {
        if (!self.upperSizes[size]) return;
        var available = self._sizeHasAnyColor(size);
        var isSelected = self.selectedSize === size;

        var btn = self._el('button', 'pc-swatch pc-swatch--size'
          + (isSelected ? ' pc-swatch--selected' : '')
          + (available ? '' : ' pc-swatch--disabled'));
        btn.type = 'button';
        btn.textContent = size;
        if (available) {
          btn.addEventListener('click', function () { self._selectSize(size); });
        } else {
          btn.disabled = true;
          btn.appendChild(self._el('span', 'pc-swatch__strikethrough'));
        }
        wrap.appendChild(btn);
      });
      section.appendChild(wrap);

      return section;
    }

    _renderColorOptions() {
      var self = this;
      var section = this._el('div', 'pc-options-section');

      var heading = this._el('p', 'pc-modal__step-heading');
      heading.innerHTML = 'Upper Color: <strong>' + (this.upperColor || '—') + '</strong>';
      section.appendChild(heading);

      var anyStruck = false;
      var wrap = this._el('div', 'pc-modal__options');
      this._availableColors().forEach(function (entry) {
        var available = !self.selectedSize || !!entry.sizes[self.selectedSize];
        if (!available) anyStruck = true;
        var isSelected = self.upperColor && self.upperColor.toLowerCase() === entry.color.toLowerCase();

        var btn = self._el('button', 'pc-swatch pc-swatch--color'
          + (isSelected ? ' pc-swatch--selected' : '')
          + (available ? '' : ' pc-swatch--disabled'));
        btn.type = 'button';
        btn.title = entry.color;
        btn.setAttribute('aria-label', entry.color
          + (available ? '' : ' — unavailable in size ' + self.selectedSize));

        var circle = self._el('span', 'pc-swatch__circle');
        var pdpSwatch = self.pdpSwatches[entry.color.toLowerCase()];
        if (pdpSwatch && pdpSwatch.image) {
          circle.style.backgroundImage = pdpSwatch.image;
        } else if (pdpSwatch && pdpSwatch.color) {
          circle.style.backgroundColor = pdpSwatch.color;
        } else if (entry.swatchUrl) {
          /* No PDP swatch for this color — fall back to the upper's image */
          var joiner = entry.swatchUrl.indexOf('?') === -1 ? '?' : '&';
          circle.style.backgroundImage = 'url(' + entry.swatchUrl + joiner + 'width=100)';
        }
        btn.appendChild(circle);

        if (available) {
          btn.addEventListener('click', function () { self._selectColor(entry.color); });
        } else {
          btn.disabled = true;
          circle.appendChild(self._el('span', 'pc-swatch__circle-strike'));
        }
        wrap.appendChild(btn);
      });
      section.appendChild(wrap);

      if (anyStruck && this.selectedSize) {
        var note = this._el('p', 'pc-modal__grid-hint');
        note.textContent = 'Crossed-out colors aren’t available in size ' + this.selectedSize + '.';
        section.appendChild(note);
      }

      return section;
    }

    _renderOptionsFooter() {
      var self = this;
      var footer = this._el('div', 'pc-modal__footer');

      var btn = document.createElement('button');
      btn.className = 'btn btn--primary btn--solid pc-atc-btn pc-continue-btn';
      var ready = this._comboAvailable();
      btn.textContent = ready
        ? 'Choose Your Heel Kits'
        : (!this.selectedSize ? 'Select a size' : 'Select an upper color');
      btn.disabled = !ready;
      btn.addEventListener('click', function () {
        self.screen = 'kits';
        self._render();
      });
      footer.appendChild(btn);

      return footer;
    }

    /* --- Screen 2: heel kit grid --- */

    _renderHeader() {
      var header = this._el('div', 'pc-modal__header');

      var title = this._el('h2', 'pc-modal__title');
      title.textContent = 'Build Your ' + this.productStyle + ' Bundle';
      header.appendChild(title);

      var meta = this._el('p', 'pc-modal__size-label');
      var parts = [];
      if (this.selectedSize) parts.push('Size: ' + this.selectedSize);
      if (this.upperColor) parts.push(this.upperColor);
      meta.textContent = parts.join('  ·  ');

      var change = this._el('button', 'pc-modal__change-btn');
      change.type = 'button';
      change.textContent = 'Change';
      change.setAttribute('aria-label', 'Change size or upper color');
      var self = this;
      change.addEventListener('click', function () {
        self.screen = 'options';
        self._render();
      });
      meta.appendChild(change);
      header.appendChild(meta);

      var hint = this._el('p', 'pc-modal__grid-hint');
      hint.textContent = 'Tap a heel kit to preview it on your ' + this.productStyle + '. Check the box to add it to your bundle.';
      header.appendChild(hint);

      return header;
    }

    /* Distinct heel types present in the grid, in HEEL_TYPES order */
    _kitTypes() {
      var types = [];
      this.gridKits.forEach(function (kit) {
        if (kit.type && types.indexOf(kit.type) === -1) types.push(kit.type);
      });
      return types;
    }

    _kitMatchesFilters(kit, typeFilter, heightFilter, colorFilter) {
      return (typeFilter === 'all' || kit.type === typeFilter)
        && (heightFilter === 'all' || kit.height === heightFilter)
        && (colorFilter === 'all' || (kit.colorTags || []).indexOf(colorFilter) !== -1);
    }

    _filteredKits() {
      var self = this;
      return this.gridKits.filter(function (kit) {
        return self._kitMatchesFilters(kit, self.kitFilter, self.kitHeightFilter, self.kitColorFilter);
      });
    }

    /* Heights present in the grid, in display order */
    _kitHeights() {
      var present = {};
      this.gridKits.forEach(function (kit) { present[kit.height] = true; });
      return [3, 4, 15].filter(function (h) { return present[h]; });
    }

    /* Distinct category Color labels present in the grid, alphabetical */
    _kitColors() {
      var colors = [];
      this.gridKits.forEach(function (kit) {
        (kit.colorTags || []).forEach(function (c) {
          if (colors.indexOf(c) === -1) colors.push(c);
        });
      });
      return colors.sort();
    }

    _heightLabel(height) {
      return (height === 15 ? '1.5' : height) + '"';
    }

    /* Sticky filter rows: heel-type tabs plus Heel Height and Color rows
       below. Filtering only changes what's shown — selections persist.
       Changing one filter resets any other whose value no longer matches
       anything; options with no kits under the other filters disable. */
    _renderKitTabs() {
      var self = this;
      var types = this._kitTypes();
      var heights = this._kitHeights();
      var colors = this._kitColors();
      var wrap = this._el('div', 'pc-kit-filters');

      /* Reset stale secondary filters after a change to another row */
      var resetInvalidFilters = function () {
        if (self.kitHeightFilter !== 'all' && !self.gridKits.some(function (kit) {
          return self._kitMatchesFilters(kit, self.kitFilter, self.kitHeightFilter, 'all');
        })) {
          self.kitHeightFilter = 'all';
        }
        if (self.kitColorFilter !== 'all' && !self.gridKits.some(function (kit) {
          return self._kitMatchesFilters(kit, self.kitFilter, self.kitHeightFilter, self.kitColorFilter);
        })) {
          self.kitColorFilter = 'all';
        }
      };

      if (types.length >= 2) {
        var tabs = this._el('div', 'pc-kit-tabs');
        var typeLabel = this._el('span', 'pc-kit-tabs__label');
        typeLabel.textContent = 'Style:';
        tabs.appendChild(typeLabel);
        var typePills = this._el('div', 'pc-kit-tabs__scroll');
        ['all'].concat(types).forEach(function (type) {
          var isActive = self.kitFilter === type;
          var tab = self._el('button', 'pc-kit-tab' + (isActive ? ' pc-kit-tab--active' : ''));
          tab.type = 'button';
          tab.textContent = type === 'all' ? 'All' : type;
          tab.setAttribute('aria-pressed', isActive ? 'true' : 'false');
          tab.addEventListener('click', function () {
            if (self.kitFilter === type) return;
            self.kitFilter = type;
            resetInvalidFilters();
            self._renderKeepingScroll();
          });
          typePills.appendChild(tab);
        });
        tabs.appendChild(typePills);
        wrap.appendChild(tabs);
      }

      if (heights.length >= 2) {
        var row = this._el('div', 'pc-kit-tabs pc-kit-tabs--heights');
        var label = this._el('span', 'pc-kit-tabs__label');
        label.textContent = 'Heel Height:';
        row.appendChild(label);
        var heightPills = this._el('div', 'pc-kit-tabs__scroll');

        ['all'].concat(heights).forEach(function (height) {
          var isActive = self.kitHeightFilter === height;
          var hasKits = height === 'all' || self.gridKits.some(function (kit) {
            return self._kitMatchesFilters(kit, self.kitFilter, height, self.kitColorFilter);
          });
          var tab = self._el('button', 'pc-kit-tab pc-kit-tab--height'
            + (isActive ? ' pc-kit-tab--active' : ''));
          tab.type = 'button';
          tab.textContent = height === 'all' ? 'All' : self._heightLabel(height);
          tab.setAttribute('aria-pressed', isActive ? 'true' : 'false');
          if (!hasKits) {
            tab.disabled = true;
          } else {
            tab.addEventListener('click', function () {
              if (self.kitHeightFilter === height) return;
              self.kitHeightFilter = height;
              resetInvalidFilters();
              self._renderKeepingScroll();
            });
          }
          heightPills.appendChild(tab);
        });
        row.appendChild(heightPills);
        wrap.appendChild(row);
      }

      if (colors.length >= 2) {
        var colorRow = this._el('div', 'pc-kit-tabs pc-kit-tabs--colors');
        var colorLabel = this._el('span', 'pc-kit-tabs__label');
        colorLabel.textContent = 'Color:';
        colorRow.appendChild(colorLabel);

        /* Long list — one scrollable line instead of wrapping */
        var colorScroll = this._el('div', 'pc-kit-tabs__scroll');

        ['all'].concat(colors).forEach(function (color) {
          var isActive = self.kitColorFilter === color;
          var hasKits = color === 'all' || self.gridKits.some(function (kit) {
            return self._kitMatchesFilters(kit, self.kitFilter, self.kitHeightFilter, color);
          });
          var tab = self._el('button', 'pc-kit-tab pc-kit-tab--color'
            + (isActive ? ' pc-kit-tab--active' : ''));
          tab.type = 'button';
          tab.textContent = color === 'all' ? 'All' : color;
          tab.setAttribute('aria-pressed', isActive ? 'true' : 'false');
          if (!hasKits) {
            tab.disabled = true;
          } else {
            tab.addEventListener('click', function () {
              if (self.kitColorFilter === color) return;
              self.kitColorFilter = color;
              self._renderKeepingScroll();
            });
          }
          colorScroll.appendChild(tab);
        });
        colorRow.appendChild(colorScroll);
        wrap.appendChild(colorRow);

        /* Each render rebuilds the row at scrollLeft 0 — bring the active
           pill back into view once it's laid out */
        if (this.kitColorFilter !== 'all') {
          requestAnimationFrame(function () {
            var active = colorScroll.querySelector('.pc-kit-tab--active');
            if (!active) return;
            var scrollRect = colorScroll.getBoundingClientRect();
            var activeRect = active.getBoundingClientRect();
            colorScroll.scrollLeft += activeRect.left - scrollRect.left
              - (scrollRect.width - activeRect.width) / 2;
          });
        }
      }

      if (!wrap.childNodes.length) return document.createDocumentFragment();
      return wrap;
    }

    _renderKitGrid() {
      var self = this;
      var wrap = this._el('div', 'pc-modal__options pc-modal__options--grid');

      if (!this.gridKits.length) {
        var empty = this._el('p', 'pc-modal__grid-hint');
        empty.textContent = this.loaded
          ? 'No heel kits available in this size right now.'
          : 'Loading heel kits...';
        wrap.appendChild(empty);
        return wrap;
      }

      var filtered = this._filteredKits();
      if (!filtered.length) {
        var noMatch = this._el('p', 'pc-modal__grid-hint');
        noMatch.textContent = 'No heel kits match these filters.';
        wrap.appendChild(noMatch);
        return wrap;
      }

      filtered.forEach(function (kit) {
        var isSelected = !!self.selectedKitIds[self._kitId(kit)];
        var isPreviewed = self.previewKit && self._kitId(self.previewKit) === self._kitId(kit);

        var card = self._el('div', 'pc-kit-card' + (isSelected ? ' pc-kit-card--selected' : '') + (isPreviewed ? ' pc-kit-card--previewed' : ''));

        /* Composite thumbnail: upper at the kit's height + kit heel */
        var upperForKit = (self.topImages && self.topImages[kit.height]) || self.topImage;
        var stack = self._el('div', 'pc-image-stack');
        if (upperForKit && upperForKit.upperImageUrl) {
          var upperImg = document.createElement('img');
          upperImg.className = 'pc-image-stack__upper';
          upperImg.src = upperForKit.upperImageUrl;
          upperImg.alt = self.productStyle + ' upper';
          upperImg.loading = 'lazy';
          stack.appendChild(upperImg);
        }
        var heelImg = document.createElement('img');
        heelImg.className = 'pc-image-stack__heel';
        heelImg.src = kit.heelImageUrl;
        heelImg.alt = self._kitLabel(kit);
        heelImg.loading = 'lazy';
        stack.appendChild(heelImg);
        card.appendChild(stack);

        /* Select checkbox */
        var check = self._el('button', 'pc-kit-card__check');
        check.type = 'button';
        check.setAttribute('role', 'checkbox');
        check.setAttribute('aria-checked', isSelected ? 'true' : 'false');
        check.setAttribute('aria-label', (isSelected ? 'Remove ' : 'Add ') + self._kitLabel(kit) + (isSelected ? ' from' : ' to') + ' bundle');
        check.innerHTML = isSelected
          ? '<svg width="12" height="10" viewBox="0 0 12 10" fill="none"><path d="M1 5l3.5 3.5L11 1" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>'
          : '';
        check.addEventListener('click', function (e) { e.stopPropagation(); self._toggleKit(kit); });
        card.appendChild(check);

        /* Label */
        var label = self._el('p', 'pc-kit-card__label');
        label.textContent = self._kitLabel(kit);
        card.appendChild(label);

        /* Tapping the card previews it; only the checkbox selects */
        card.addEventListener('click', function () { self.previewKit = kit; self._render(); });

        wrap.appendChild(card);
      });

      return wrap;
    }

    _kitLabel(kit) {
      var height = kit.height === 15 ? '1.5"' : kit.height + '"';
      return (kit.color ? kit.color + ' ' : '') + (kit.type || '') + ' ' + height;
    }

    _renderPricingBar() {
      var self = this;
      var kits = this._selectedKits();
      var pricing = getBundlePricing(this.topImage, kits, this.discountTiers);
      var wrap = this._el('div', 'pc-tray-wrap');
      var bar = this._el('div', 'pc-tray');

      var info = this._el('div', 'pc-tray__info');
      var totalLine = this._el('span', 'pc-tray__total');
      var kitWord = kits.length === 1 ? 'heel kit' : 'heel kits';
      if (pricing.savings > 0) {
        totalLine.innerHTML = kits.length + ' ' + kitWord + ' · <strong>' + formatMoney(pricing.total) + '</strong> <s>' + formatMoney(pricing.retailTotal) + '</s> · You save ' + pricing.discountPercent + '%';
      } else {
        totalLine.innerHTML = kits.length + ' ' + kitWord + ' · <strong>' + formatMoney(pricing.total) + '</strong>';
      }
      info.appendChild(totalLine);

      var upcoming = getUpcomingTiers(this.discountTiers, kits.length);
      if (upcoming.length) {
        var more = upcoming[0].minKits - kits.length;
        var nudge = this._el('span', 'pc-tray__nudge');
        nudge.textContent = 'Add ' + more + ' more heel kit' + (more === 1 ? '' : 's') + ' & save ' + upcoming[0].discount + '%';
        info.appendChild(nudge);
      }
      bar.appendChild(info);

      /* "See Your Bundle" — the whole bar toggles the panel */
      var toggle = this._el('button', 'pc-tray__view' + (this.bundleOpen ? ' pc-tray__view--open' : ''));
      toggle.type = 'button';
      toggle.setAttribute('aria-expanded', this.bundleOpen ? 'true' : 'false');
      toggle.innerHTML = 'See Your Bundle <svg width="10" height="6" viewBox="0 0 10 6" fill="none" aria-hidden="true"><path d="M1 5l4-4 4 4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      bar.appendChild(toggle);
      bar.addEventListener('click', function () {
        self.bundleOpen = !self.bundleOpen;
        self._render();
      });

      wrap.appendChild(bar);
      if (this.bundleOpen) wrap.appendChild(this._renderBundlePanel(kits, pricing));
      return wrap;
    }

    /* Expanded bundle panel: price breakdown + component thumbs with removal */
    _renderBundlePanel(kits, pricing) {
      var self = this;
      var panel = this._el('div', 'pc-bundle-panel');

      var lines = this._el('div', 'pc-bundle-panel__lines');
      var breakdown = this._el('div', 'pc-bundle-panel__breakdown');
      if (pricing.savings > 0) {
        var retail = this._el('span');
        retail.textContent = 'Retail Price: ' + formatMoney(pricing.retailTotal);
        breakdown.appendChild(retail);
        var savings = this._el('span');
        savings.textContent = 'Savings: ' + formatMoney(pricing.savings) + ' (' + pricing.discountPercent + '%)';
        breakdown.appendChild(savings);
      }
      lines.appendChild(breakdown);
      var total = this._el('span', 'pc-bundle-panel__total');
      total.textContent = 'Total: ' + formatMoney(pricing.total);
      lines.appendChild(total);
      panel.appendChild(lines);

      var thumbs = this._el('div', 'pc-bundle-panel__thumbs');

      /* Upper: part of every bundle, no removal */
      if (this.topImage && this.topImage.featuredImage && this.topImage.featuredImage.url) {
        var upperThumb = this._el('div', 'pc-bundle-thumb');
        var upperImg = document.createElement('img');
        upperImg.src = this.topImage.featuredImage.url;
        upperImg.alt = this.productStyle + ' upper';
        upperThumb.appendChild(upperImg);
        thumbs.appendChild(upperThumb);
      }

      kits.forEach(function (kit) {
        var thumb = self._el('div', 'pc-bundle-thumb');
        if (kit.featuredImage && kit.featuredImage.url) {
          var img = document.createElement('img');
          img.src = kit.featuredImage.url;
          img.alt = self._kitLabel(kit);
          thumb.appendChild(img);
        }
        var remove = self._el('button', 'pc-bundle-thumb__remove');
        remove.type = 'button';
        remove.setAttribute('aria-label', 'Remove ' + self._kitLabel(kit) + ' from bundle');
        remove.innerHTML = '<svg width="10" height="10" viewBox="0 0 10 10" fill="none" aria-hidden="true"><path d="M1 1l8 8M9 1L1 9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>';
        remove.addEventListener('click', function () { self._toggleKit(kit); });
        thumb.appendChild(remove);
        thumbs.appendChild(thumb);
      });

      panel.appendChild(thumbs);
      return panel;
    }

    _renderFooter() {
      var self = this;
      var kits = this._selectedKits();
      var pricing = getBundlePricing(this.topImage, kits, this.discountTiers);
      var footer = this._el('div', 'pc-modal__footer');

      var nav = this._el('div', 'pc-modal__footer-nav');
      nav.style.display = 'flex';
      nav.style.justifyContent = 'space-between';
      nav.style.alignItems = 'center';
      nav.style.gap = '15px';
      nav.style.width = '100%';

      /* Add to bag */
      var btn = document.createElement('button');
      btn.className = 'btn btn--primary btn--solid pc-atc-btn';
      btn.textContent = kits.length
        ? 'Add to Bag — ' + formatMoney(pricing.total)
        : 'Select a heel kit';
      btn.disabled = kits.length === 0 || !this.topImage || !this.topImage.variant;
      btn.addEventListener('click', function () {
        var bundleTitle = self.productStyle + (self.upperColor ? ' ' + self.upperColor : '') + ' Bundle';
        handleBundleAddToCart(btn, self.dataset.bundleParentVariant, self.topImage, self._selectedKits(), self.discountTiers, self.quantity, bundleTitle, self._bundleUrl(), function () {
          self.close();
        });
      });
      nav.appendChild(btn);

      footer.appendChild(nav);
      return footer;
    }

    /* --- Utility --- */

    _el(tag, className) {
      var el = document.createElement(tag);
      if (className) el.className = className;
      return el;
    }
  });

}();